import { VenueReview } from "common/types";
import { useI18N } from "common/hooks";
import { useState } from "react";
import { ShareExperience } from "@/components/VenueDetailBasic/ShareExperience";
import { FolderDottedIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { VenueDetails } from "common/types";
import { Helmet } from "react-helmet";


type ReviewsTabProps = {
  reviews: VenueReview[];
  fullSize?: boolean;
  onFlag: (review: any) => void;
  isLoggedIn: boolean;
  onShowLoginModal: () => void;
  venueDetails: VenueDetails;
  currentReviewSort: string;
  onReviewSort: (value: string) => void;
  sortByText: string;
};

function ReviewsTab({
  reviews,
  fullSize,
  onFlag,
  isLoggedIn,
  onShowLoginModal,
  venueDetails,
  currentReviewSort,
  onReviewSort,
  sortByText,
}: ReviewsTabProps) {
  const i18n = useI18N();
  const [isAddReviewOpen, setIsAddReviewOpen] = useState(false);

  const handleAddReviewClose = () => {
    setIsAddReviewOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>
          {venueDetails?.name
            ? `${venueDetails.name.length > 30 ? venueDetails.name.substring(0, 30) + "..." : venueDetails.name}`
            : ""}
          | Experiences | Sociability
        </title>
      </Helmet>

      <div className="flex flex-col w-full overflow-x-hidden min-h-[calc(100vh-200px)]">
        {/* Empty State */}
        {reviews?.length === 0 && (
          <div className="flex flex-1 flex-col justify-start sm:justify-center items-center px-4 pt-8 sm:pt-0">
            <FolderDottedIcon size={32} className="text-fg-neutral-strong" />
            <p className="text-center title-s-semibold text-fg-neutral-strong mt-3">
              {i18n.get("beTheFirstToShareYourExperience")}
            </p>
            <p className="text-center label-s-regular text-fg-neutral-subtle mt-2 max-w-sm">
              {i18n.get("tapShareExperienceToHelpOthersBySharingYourAccessibilityExperience")}
            </p>
          </div>
        )}

        {/* Reviews Content */}
        {reviews?.length > 0 && (
          <ShareExperience
            totalCount={reviews?.length || 10}
            currentSort={currentReviewSort}
            onSortChange={onReviewSort}
            reviews={reviews}
            onFlag={onFlag}
            venueAccessibilityExperienceStats={venueDetails?.venueAccessibilityExperienceStats}
          />
        )}
      </div>
    </>
  );
}

export default ReviewsTab;
